<form class="container-fluid" [formGroup]="VendorInviteFormGroup">
  <div class="row row-padding justify-content-center">
    <div class="col-auto">
      <label class="fs-28">Invite Vendor</label>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <label>Email<span class="required-field-asterisk">*</span></label>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <input type="text" class="form-control" formControlName="inviteEmail" />
    </div>
  </div>
  <div class="row row-padding">
    <div class="col">
      <button class="btn btn-primary" (click)="close()">Cancel</button>
    </div>
    <div class="col">
      <button class="btn btn-primary" (click)="send()">Send</button>
    </div>
  </div>
</form>
